import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { Badge } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

import type { IAiTrackerCampaign } from "../shared/types";

const StyledDemoBox = styled(Box)`
    background: ${colorsPalettes.carbon[0]};
    border-radius: 8px;
    padding: 16px;
    margin: 24px;
    width: 400px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 4px 8px ${colorsPalettes.carbon[100]};
    }
`;

interface IDemoBoxProps {
    campaign: IAiTrackerCampaign;
    onDemoCampaignClick: (campaign: IAiTrackerCampaign) => void;
}

export const DemoBox = ({ campaign, onDemoCampaignClick }: IDemoBoxProps) => {
    const handleClick = () => {
        onDemoCampaignClick(campaign);
    };

    return (
        <StyledDemoBox onClick={handleClick}>
            <Flex
                alignItems="center"
                justifyContent="space-between"
            >
                <img
                    width={118}
                    height={40}
                    src={AssetsService.assetUrl("images/keywords-campaigns/files/demoCampaignLogo.svg")}
                    alt={""}
                />
                <Badge type="custom" bgColor={colorsPalettes.bluegrey[400]}>
                    {translate("llm.homepage.demo.pill")}
                </Badge>
            </Flex>
        </StyledDemoBox>
    );
};
